import { render } from "./MyCollectionView.vue?vue&type=template&id=58256880&scoped=true"
import script from "./MyCollectionView.vue?vue&type=script&lang=js"
export * from "./MyCollectionView.vue?vue&type=script&lang=js"

import "./MyCollectionView.vue?vue&type=style&index=0&id=58256880&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58256880"]])

export default __exports__